import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import i18n from "@/i18n";
import mixins from "@/mixins"

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.prototype.wlocation = window.location
Vue.prototype.navigator = navigator
Vue.prototype.window = window
Vue.prototype.document = document

import store from '@/store'

Vue.mixin(mixins);

new Vue({
  i18n,
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
